const ON = 'on';

class BaseModule {
    constructor(o) {
        // console.log(this.classID + ' init');
        this.name = o.name;
        this.id = o.id;
        this.el = o.el;
        this.$el = $(o.el);

        // options from data-[moduleName] attribute
        let dataID = Z.decamelize(o.name),
            options = $.extend({}, this.$el.data(dataID));
        if (options) Object.assign(this, options);

        // json in ModuleData twig block
        if (window.ModuleData) {
            let json = ModuleData[this.$el.data(dataID + "-json")];
            if (json) Object.assign(this, json);
        }

        $(o.el).attr('data-' + dataID, o.id);
        this._subscribes = new Set(); // Array of strings: Methods names to autosubscribe on enable
        this._selfElementEvents = []; // Array of strings: Element events to register on enable.
        this._elementsEvents = []; // Array of arrays [$el, 'event', 'method'] events to register on enable.
        this._listeners = {}; // Array of methods with binds to 'this'

        this.enabled = false;
    }

    afterInit () { }

    // set enable flag and register events to handlers
    enable () {
        if (this.enabled) return;
        this.enabled = true;
        this.setEvents(...this._elementsEvents);
        this.elOn(...this._selfElementEvents);
        this.subscribe(...this._subscribes);
    }

    // unset enable flag and unregister events
    disable () {
        if (!this.enabled) return;
        this.enabled = this.active = false;
        this.unsubscribe(...this._subscribes);
        this.elOff(...this._selfElementEvents);
        this.unsetEvents(...this._elementsEvents);
    }

    destroy () {
        this.disable();
        delete this.el.dataset[this.name];
    }

    getListener (methodName) {
        return this._listeners[methodName];
    }
	/**
	 * Creates a handler if not already exists binding this
	 * @param {The method name of the class} methodName
	 */
    addListener (methodName) {
        methodName = /[^;\-\.]*/.exec(methodName)[0];
        this.createListeners(methodName)
        return this._listeners[methodName];
    }
    createListeners (...methodNames) {
        let { _listeners } = this;
        methodNames.forEach(name => {
            if (!this[name]) console.error("undefined method: " + name);
            _listeners[name] = _listeners[name] || this[name].bind(this);
        });
    }

    addSubscribes (...events) {
        events.forEach(e => this._subscribes.add(e));
    }
	/**
	 * Subscribe to one or more events
	 * To automate it, events and methods must have same names
	 * @param  {...string} methods Events / methods to subscribe
	 */
    subscribe (...methods) {
        methods.forEach(e => Z.on(e, this.addListener(ON + e)));
    }
    unsubscribe (...methods) {
        methods.forEach(e => Z.off(e, this._listeners[ON + e]));
    }
    removeSubscribe (e) {
        Z.off(e, this._listeners[ON + e]);
        this._subscribes.delete(e);
    }

	/**
	 * Apply one or more events to the main element of the module
	 * The event and the method must have the same name
	 * @param  {...string} methods Events / methods array to apply
	 */
    elOn (...methods) {
        methods.forEach(e => this.$el.on(e, this.addListener(ON + Z.capitalizeFirst(e))));
    }
    elOff (...methods) {
        methods.forEach(e => this.$el.off(e, this._listeners[ON + Z.capitalizeFirst(e)]));
    }
    addSelfEvents (...events) {
        this._selfElementEvents.push(...events);
    }

    setEvent ($el, event, methodName) {
        $el.on(event, this.addListener(methodName));
    }
    unsetEvent ($el, event, methodName) {
        $el.off(event, this._listeners[methodName]);
    }
    setEvents (...events) {
        events.forEach(ev => this.setEvent(ev[0], ev[1], ev[2]));
    }
    unsetEvents (...events) {
        events.forEach(ev => this.unsetEvent(ev[0], ev[1], ev[2]));
    }
    // event: [$el:jquery, event:String, method:string]
    addEvents (...events) {
        events.forEach(e => {
            if (e[0] && e[0].length) this._elementsEvents.push(e);
        });
    }

	/**
	 * Read data from element attributes and assigns them to
	 * @param {object} props Object of propertyName: defaultValue
	 * @param {string} prefix Object of propertyName: defaultValue
	 * @param {object} obj Object to assign the props (this instance by default)
	 */
    getDataObj (props, prefix, obj = this) {
        let attr;
        prefix = prefix ? prefix + '-' : '';
        for (let prop in props) {
            attr = prefix + prop;
            obj[Z.toCamel(prop)] = this.el.hasAttribute('data-' + attr) ? this.$el.data(attr) : props[prop];
            // this.$el.removeAttr('data-' + prop);
        }
    }
    getDataToVars (props, prefix) {
        prefix = prefix ? prefix + '-' : '';
        props.forEach(prop => {
            this[Z.toCamel(prop)] = this.$el.data(prefix + prop);
            // this.$el.removeAttr('data-' + prop);
        });
    }

    // Reads data attributes without default values and no prefix
    getData (...props) {
        props.forEach(prop => {
            this[Z.toCamel(prop)] = this.$el.data(prop);
            // this.$el.removeAttr('data-' + prop);
        });
    }
    getSelector (dataSelector, defaultSelector, $context = this.$el, $defaultContext = this.$el) {
        let $el, selector = this.$el.data(dataSelector);
        if (selector) $el = $context.find(selector)
        return $el && $el.length ? $el : $defaultContext.find(defaultSelector);
    }
    dataSelector (dataAttr, globalAttr) {
        let selector = this.$el.data(dataAttr);
        return selector ? $(document.querySelectorAll(selector)) : (globalAttr ? $(globalAttr) : null);
    }

	/**
	 * Thin wrapper for the $(el).find to search inside the module element
	 * @param {string} selector A valid dom selector
	 */
    find (selector) {
        if (!selector) return null;
        let $el = this.$el.find(selector);
        return $el.length ? $el : null;
    }
    display (displayMode) {
        this.$el.css({ display: displayMode });
    }

	/**
	 * Sets a class property to a value.
	 * Returns true if the is not equals the value
	 * @param {*} propertyName
	 * @param {*} newVal
	 */
    setProperty (propertyName, newVal) {
        if (this[propertyName] == newVal) return false;
        this[propertyName] = newVal;
        return true;
    }

    findModule (name) {
        return Z.getModule(name, this.$el.find('[data-' + Z.decamelize(name) + ']'));
    }

}

export default BaseModule
